import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modern-template-default-home-page',
  templateUrl: './modern-template-default-home.page.html',
  styleUrls: ['./modern-template-default-home.page.scss'],
})
export class ModernTemplateDefaultHomePage implements OnInit {
  selectedCategoryId;
  selectedStoreValue;
  changingCategory;
  changingSort;

  constructor() { }

  ngOnInit() {
  }

  changeCategory(event) {
    this.changingCategory = true
    this.selectedCategoryId = event.id
    setTimeout(() => {
      this.changingCategory = false
    }, 500)

  }

  sortProducts(event){
    this.changingSort = true
    this.selectedStoreValue = event.value
    setTimeout(() => {
      this.changingSort = false
    }, 500)
  }

}
